export function BrandIdentity() {
  return (
    <>
      <span className="brand-mark" aria-hidden="true">
        <img className="brand-logo-dark" src="/brand/panamorphix-kasa-white.png" alt="" />
        <img className="brand-logo-light" src="/brand/panamorphix-kasa-black.png" alt="" />
      </span>
      <span className="brand-wordmark">
        <strong>
          Panamorphix
          <br />
          Intelligence
        </strong>
        <span className="brand-product">Terminal</span>
      </span>
    </>
  );
}
